module.exports = __webpack_public_path__ + "static/media/space_cloud_ibm.1b5209c6.svg";